import { render, staticRenderFns } from "./BaseArrow.vue?vue&type=template&id=6337c63c"
import script from "./BaseArrow.vue?vue&type=script&lang=js"
export * from "./BaseArrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports